import ShortTextOutlined from '@mui/icons-material/ShortTextOutlined';
import SubjectOutlined from '@mui/icons-material/SubjectOutlined';
import { s } from '../../format/schema';
import { defineFieldType } from '../card';
import { oneLine } from 'framework/utils';
import { TextFieldInput } from './FillInput';
import { TextFieldSettingsPanel } from './SettingsPanel';

export const textField = defineFieldType({
  type: 'textField',
  name: 'Text field',
  valueKind: 'text',
  settings: s.strictObject({ multiline: s.boolean().optional() }),
  defaults: { multiline: false },
  canResize: settings => !settings.multiline,
  value: s.string(),
  emptyValue: '',
  hasDefaultValue: true,
  validations: ['required', 'range', 'unique', 'pattern'],
  operators: ['isFilled', 'isEmpty', 'equals', 'notEquals', 'contains', 'notContains', 'startsWith', 'endsWith'],
  palette: [
    { name: 'Text field', tooltip: 'One line of text', group: 'Text', icon: ShortTextOutlined },
    {
      name: 'Text area',
      tooltip: 'Several lines of text',
      group: 'Text',
      icon: SubjectOutlined,
      settings: { multiline: true },
    },
  ],
  isEmpty: value => value.trim() === '',
  quantity: value => [...value.trim()].length,
  comparable: value => value.trim().toLowerCase(),
  stored: (value, settings) => (settings.multiline ? value : oneLine(value)).trim(),
  FillInput: TextFieldInput,
  settingsPanel: { at: 'general', Panel: TextFieldSettingsPanel },
});
